import React from "react";
import { Route, Redirect } from "react-router-dom";
import { read } from "Helpers/LocalStorage";
import { logout } from "Stores/actions";
import { push } from "Helpers/History";

const SuperRoute = ({
  component: Component,
  restricted,
  props,
  isLoggedIn,
  ...res
}) => {

  const check = (key) => {
    if(read(key) && read(key).accessShow) return true;
    else return false;
  }

  const renderComponent = (props) => {
    const pathSplit = res.location.pathname.split("/");
    if (pathSplit[1] === "admin") {
      if (
        (pathSplit[2] === "pricing" && check("FormPriceSuperAdmin")) ||
        (pathSplit[2] === "support" && check("FormCustomerSupport")) ||
        (pathSplit[2] === "tickets" && check("Support")) ||
        (pathSplit[2] === "notices" && check("Notice")) ||
        (pathSplit[2] === "financial" && (check("Financial") || check("FormDefaultCredit") || check("FormDefaultPanel"))) ||
        (pathSplit[2] === "tools" && (check("FormDiscount") || check("FormIncTime") || check("FormManualCredit"))) ||
        (pathSplit[2] === "statistics" && check("Statistics"))
      ) {
        if (pathSplit[3]) {
          if (
            (pathSplit[3] === "incCredit" && check("FormManualCredit")) ||
            (pathSplit[3] === "incTime" && check("FormIncTime")) ||
            (pathSplit[3] === "discountCard" && check("FormDiscount")) ||
            (pathSplit[3] === "defaultCharges" && check("FormDefaultCredit")) ||
            (pathSplit[3] === "defaultPanel" && check("FormDefaultPanel")) ||
            (pathSplit[3] === "transactions" && check("Financial")) ||
            (pathSplit[3] === "periods" && check("FormPeriod"))
          ) {
            return <Component {...props} />;
          } else {
            const allowed = ["factors", "products", "services", "supervisor"];
            if (allowed.includes(pathSplit[3])) return <Component {...props} />;
            else return <Redirect to={`/admin/${pathSplit[2]}`} />;
          }
        } else {
          return <Component {...props} />;
        }
      } else {
        hasAccess();
      }
    } else {
      logout();
    }
  };

  const hasAccess = () => {
    if (
      check("FormPriceSuperAdmin") ||
      check("FormCustomerSupport") ||
      check("Support") ||
      check("Financial") ||
      check("FormDefaultCredit") || 
      check("FormDefaultPanel") ||
      check("FormDiscount") ||
      check("FormIncTime") ||
      check("FormManualCredit") ||
      check("Statistics")
    ) {
      return push(
        check("FormCustomerSupport") ? "/admin/support"
        : check("FormPriceSuperAdmin") ? "/admin/pricing"
        : check("Support") ? "/admin/tickets"
        : (check("Financial") || check("FormDefaultCredit") || check("FormDefaultPanel")) ? "/admin/financial"
        : (check("FormDiscount") || check("FormIncTime") || check("FormManualCredit")) ? "/admin/tools"
        : check("Statistics") ? "/admin/statistics"
        : "/admin"
      );
    } else {
      logout();
    }
  };

  return (
    <>
      <Route
        {...res}
        render={(props) => {
          return (
            <>
              {isLoggedIn ? (
                renderComponent(props)
              ) : (
                <Redirect to={`/auth/sign_in`} />
              )}
            </>
          );
        }}
      />
    </>
  );
};

export default SuperRoute;
